import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carview',
  templateUrl: './carview.page.html',
  styleUrls: ['./carview.page.scss'],
})
export class CarviewPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
